<script>
import getSecret from '@utils/get-secret'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import UserUpdateForm from '@components/roles_management/users/UserUpdateForm'
import UserCreationForm from '@components/roles_management/users/UserCreationForm'
import PasswordUpdateForm from '@components/roles_management/users/PasswordUpdateForm'
import { usersMethods, authComputed } from '@state/helpers'
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'

export default {
  name: 'UsersManagement',
  components: { Layout, PageHeader, BaseDatatable, UserCreationForm, UserUpdateForm, PasswordUpdateForm, PasswordUpdateForm },
  page: {
    title: 'Users',
    meta: [{ name: 'Users management', content: 'Users management' }],
  },
  props: {
        admon_section: {
            type: Boolean,
            default: false,
            required: false
        },
        create_user: {
            type: Boolean,
            default: false,
            required: false
        },
        isthirdpartyuser: {
            type: Boolean,
            default: false,
            required: false
            },
        thirdparty: {
            type: String,
            required: false
        },

        thirdpartyid: {
            type: Number,
            required: false
        }
        
    },
  data() {
    return {
      title: 'Users',
      items: [
        { text: 'Home', href: '/' },
        { text: 'Users', active: true },
      ],
      users: {},
      tableHeaders: [],
      detailModal: {
        id: 'info-modal',
        title: '',
        content: '',
        photo: ''
      },
      createUpdateModal: {
        id: 'create-update-modal',
        title: '',
        content: ''
      },
      createForm: {
          username: '',
          password: '',
          repeat_password: '',
          is_thirdparty_user: false,
          thirdparty:'',
          app_sections_users: []
      },
      updateForm: {
          url: '',
          username: '',
          first_name: '',
          last_name: '',
          email: '',
          // is_staff: false,
          is_superuser: false,
          is_active: true,
          is_api_user: true,
          email_subscription: true,
          user_info: {},
          groups: [],
          user_permissions: [],
          app_sections_users: []
      },
      updatePwForm: {
          url: '',
          password: '',
          repeat_password: ''
      },
      action : '',
      toDelete: {},
      actionsLoadings: {},
      createUpdateModalShow: false,
      detailModalShow: false,
      deleteModalShow: false,
      isSubmitting: false
    }
  },

  beforeMount() {
    this.tableHeaders = [
      { key: 'username', label: this.$t('username'), sortable: true },
      { key: 'first_name', label: this.$t('name'), sortable: true },
      { key: 'email', label: this.$t('email'), sortable: true },
      // { key: 'is_staff', label: 'Staff?', sortable: true },
    ]
    if ( this.admon_section ) {
      this.tableHeaders = [ ...this.tableHeaders, 
      ...[
          { key: 'is_superuser', label: this.$t('superuser'), sortable: true },
          { key: 'is_active', label: this.$t('active'), sortable: true },
        ]
      ]

    }

    this.tableHeaders = [ ...this.tableHeaders, 
      ...[
      { key: 'actions', label: this.$t('actions')},
      ]
    ]
  },
  mounted(){

  },
  validations() {

    let updateForm = {
      username: {
        required,
        minLength: minLength(4)
      },
      email: {email},
      first_name: {},
      last_name: {}
    }
    let createForm = {
      username: {
        required,
        minLength: minLength(4)
      },
      password: {
        required,
        minLength: minLength(4)
      },
      repeat_password: {
        required,
        sameAsPassword: sameAs('password')
      },
      
    }
    const updatePwForm = {
      password: {
        required,
        minLength: minLength(4)
      },
      repeat_password: {
        required,
        sameAsPassword: sameAs('password')
      },
    }
    if (this.isthirdpartyuser) {
        createForm['username'] = {...createForm['username'], email}
      }
    return { createForm, updateForm, updatePwForm}
  },
  computed: {
    ...authComputed
  },
  methods: {
    ...usersMethods,

    myProvider(ctx) {
      let params = this.$table_params(ctx)
      params += `&is_thirdparty=${this.isthirdpartyuser}`
      if (this.thirdpartyid) {
        params += `&user_info__thirdparty=${this.thirdpartyid}`
      }
      const promise = this.fetchUsers(params)
      return promise.then(data => {
        return data
      }).catch(error => {
        this.$axios_error_noty(error, this)
        return []
      })
    },
    openDetailModal(item, index, button) {
      let context = this
      context.isSubmitting = true
      context.actionsLoadings[button] = true
      context.detailModal.title = `${this.$t('user')}: ${item.username}`
      const promise = context.fetchUsersDetail(item.url)
      return promise.then(data => {
        context.detailModal.content = data
        context.detailModal.photo = data.user_info && data.user_info.photo ? data.user_info.photo : require('@assets/images/users/avatar-clear.png')
        context.detailModalShow = !context.detailModalShow
        context.isSubmitting = false
        context.actionsLoadings[button] = false
      }).catch(error => {
        context.$axios_error_noty(error, context)
        context.isSubmitting = false
        context.actionsLoadings[button] = false
      })
    },
    resetdetailModal() {
      this.detailModal.title = ''
      this.detailModal.content = ''
    },
    openCreateUpdateModal(item, index, action) {
      console.log(item)
      this.resetCreateUpdateModal(action)
      if (action === 'create'){
        this.action = 'create'
        this.createUpdateModal.title = `${this.$t('new')} ${this.$t('user')}`
      }else if (action === 'update'){
        this.action = 'update'
        this.createUpdateModal.title = `${this.$t('update')} ${this.$t('user')}`
        this.createUpdateModal.content = JSON.stringify(item, null, 2)
        this.updateForm.url = item.url
        this.updateForm.username = item.username
        this.updateForm.first_name = item.first_name
        this.updateForm.last_name = item.last_name
        this.updateForm.email = item.email
        // this.updateForm.is_staff = item.is_staff
        this.updateForm.is_superuser = item.is_superuser
        this.updateForm.is_active = item.is_active
        this.updateForm.user_info = item.user_info
        this.updateForm.email_subscription = item.user_info ? item.user_info.email_subscription : false
        this.updateForm.is_api_user = item.user_info ? item.user_info.is_api_user : false
        this.updateForm.user_permissions = item.user_permissions_filtered
        this.updateForm.groups = item.groups
        this.updateForm.app_sections_users = item.app_sections_users
      }else{
        this.action = 'password_change'
        this.createUpdateModal.title = `${item.username} ${this.$t('password_change')}`
        this.updatePwForm.url = item.url
      }
      this.createUpdateModalShow = !this.createUpdateModalShow
    },
    openDeleteModal(item, index) {
      this.toDelete = item
      this.deleteModalShow = !this.deleteModalShow
    },
    resetDeleteModal(item, index) {
      this.toDelete = {}
    },    
    deleteUser() {
      let context = this
      context.isSubmitting = true
      let reservedUsers = [
        getSecret('APP_API_USERNAME'),
        context.currentSession.user.username]
      if(!reservedUsers.includes(context.toDelete.username)){
        const promise = context.deleteUsers(context.toDelete.url)
        return promise.then(data => {
          context.$generate_toast(context, 'success', 'User deleted successfully')
          context.$refs.table.refresh()
          context.isSubmitting = false
        }).catch(error => {
          context.$axios_error_noty(error, context)
          context.isSubmitting = false
        })
      }else{
        context.$generate_toast(
          context, 
          'error', 
          'Este usuario no se puede eliminar por que esta protegido o estas autenticado con este actualmente.')
        context.isSubmitting = false
      }
    },
    resetCreateUpdateModal(action) {
      this.createUpdateModal.title = ''
      this.createUpdateModal.content = ''
      if (action === 'create'){
        this.createForm.username = ''
        this.createForm.password = ''
        this.createForm.repeat_password = ''
        this.createForm.app_sections_users = []
        this.$v.createForm.$reset();
      }else if(action === 'update'){
        this.updateForm.url = ''
        this.updateForm.username = ''
        this.updateForm.first_name = ''
        this.updateForm.last_name = ''
        this.updateForm.email = ''
        // this.updateForm.is_staff = false
        this.updateForm.is_superuser = false
        this.updateForm.email_subscription = true
        this.updateForm.is_api_user = false
        this.updateForm.is_active = true
        this.updateForm.user_permissions = []
        this.updateForm.groups = []
        this.updateForm.app_sections_users = []
        this.$v.updateForm.$reset();
      }else {
        this.updatePwForm.url = ''
        this.updatePwForm.password = ''
        this.updatePwForm.repeat_password = ''
      }
    },
    onFormSubmit(evt) {
      evt.preventDefault()
      let context = this
      context.isSubmitting = true
      if (context.$v.updateForm.$anyError) {
        context.$v.updateForm.$touch()
      }
      let form = context.action === 'create' ? context.createForm : context.action === 'update' ? context.updateForm : context.updatePwForm
      const promise = context.action === 'password_change' ? context.changePassword(form) : context.createUpdateUsers(form)
      return promise.then(data => {
        if (context.action === 'create'){
          context.$generate_toast(context, 'Correcto', 'Usuario creado correctamente')
        }else if(context.action === 'update'){
          context.$generate_toast(context, 'Correcto', 'Usuario actualizado correctamente')
          if (context.currentSession.user.username === form.username){
            this.$store.dispatch('auth/validate', true)
          }
        }else{
          context.$generate_toast(context, 'Correcto', 'Contraseña cambiada correctamente')
        }
        context.createUpdateModalShow = !context.createUpdateModalShow
        context.$refs.table.refresh()
        context.isSubmitting = false
      }).catch(error => {
        context.$axios_error_noty(error, context)
        context.isSubmitting = false
      })
    },
    async onPhotoSubmit(formData){
      let context = this
      context.isSubmitting = true
      formData.append('url', context.updateForm.url)
      return context.updatePhotos(formData).then(data => {
        context.$generate_toast(context, 'Correcto', 'Avatar actualizado correctamente')
        context.isSubmitting = false
        context.$refs.table.refresh()
        if (context.currentSession.user.username === context.updateForm.username){
          this.$store.dispatch('auth/validate', true)
        }
        return data
      }).catch(error => {
        context.$axios_error_noty(error, context)
        context.isSubmitting = false
        throw error
      })
      
    }
  }
}
</script>

<template> 
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <b-card  class="border" border-variant="light">
            
            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
              >

              <template v-slot:buttons v-if="create_user">
                <b-button
              variant="outline-primary rounded-lg"
              @click="openCreateUpdateModal(null, null, 'create')"
              >
              <i class="fas fa-plus"></i>
            </b-button>
              </template>
              <template v-slot:cell(username)="data">
                {{ data.value.charAt(0).toUpperCase() + data.value.slice(1) }}
              </template>
              <template v-slot:cell(first_name)="data">
                {{ data.value.charAt(0).toUpperCase() + data.value.slice(1) }} {{ data.item.last_name.charAt(0).toUpperCase() + data.item.last_name.slice(1) }}
              </template>
              <!-- <template v-slot:cell(is_staff)="data">
                <i v-if="data.value" class="fe-check-circle" style="color: green"></i>
                <i v-if="!data.value" class="fe-x-circle" style="color: red"></i>
              </template> -->

              <template v-slot:cell(is_superuser)="data">
                <i v-if="data.value" class="fe-check-circle" style="color: green"></i>
                <i v-if="!data.value" class="fe-x-circle" style="color: red"></i>
              </template>

              <template v-slot:cell(is_active)="data">
                <i v-if="data.value" class="fe-check-circle" style="color: green"></i>
                <i v-if="!data.value" class="fe-x-circle" style="color: red"></i>
              </template>

              <template v-slot:cell(actions)="row">
                  <b-button-group size="xs">
                    <b-button
                      :id="`info-btn-${row.index}`"
                      variant="outline-info btn-transparent"
                      size="xs"
                      :disabled="isSubmitting || actionsLoadings[`info-btn-${row.index}`]"
                      @click="openDetailModal(row.item, row.index, `info-btn-${row.index}`)"
                      >
                      <i v-if="!actionsLoadings[`info-btn-${row.index}`]" class="fe-info fe-2x"></i>
                      <b-spinner
                        v-if="actionsLoadings[`info-btn-${row.index}`]"
                        small
                        label="Spinning"
                        variant="info"
                        >
                      </b-spinner>
                    </b-button>
                    <b-tooltip
                      :target="`info-btn-${row.index}`"
                      triggers="hover"
                      variant="info">
                      {{$t('detail')}}
                    </b-tooltip>

                    <b-button
                      :id="`update-btn-${row.index}`"
                      variant="outline-warning btn-transparent"
                      size="xs"
                      :disabled="isSubmitting"
                      @click="openCreateUpdateModal(row.item, row.index, 'update')"
                      >
                      <i class="fe-edit fe-2x"></i>
                    </b-button>
                    <b-tooltip
                      :target="`update-btn-${row.index}`"
                      triggers="hover"
                      variant="warning">
                      {{$t('edit')}}
                    </b-tooltip>

                    <b-button
                      :id="`update-pw-btn-${row.index}`"
                      variant="outline-secondary  btn-transparent"
                      size="xs"
                      :disabled="isSubmitting"
                      @click="openCreateUpdateModal(row.item, row.index, 'password_change')"
                      >
                      <i class="fe-lock fe-2x"></i>
                    </b-button>
                    <b-tooltip
                      :target="`update-pw-btn-${row.index}`"
                      triggers="hover"
                      variant="secondary">
                      {{$t('password_change')}}
                    </b-tooltip>

                    <b-button
                      :id="`delete-btn-${row.index}`"
                      variant="outline-danger btn-transparent"
                      size="xs"
                      :disabled="isSubmitting"
                      @click="openDeleteModal(row.item, row.index)"
                      >
                      <i class="fe-x fe-2x"></i>
                    </b-button>
                    <b-tooltip
                      :target="`delete-btn-${row.index}`"
                      triggers="hover"
                      variant="danger">
                      {{$t('delete')}}
                    </b-tooltip>
                    
                  </b-button-group>
              </template>

            </BaseDatatable>
          </b-card>
        </b-col>
      </b-row>
          <!-- Detail modal -->
    <b-modal 
      :id="detailModal.id"
      v-model="detailModalShow"
      :title="detailModal.title"
      ok-only
      @hide="resetdetailModal"
      >

      <!--{{detailModal.content}}-->
      <table>
        <tr>
          <td width="140px">
            <img id="image_avatar" class="user-image" :src="detailModal.photo" />
          </td>
          <td>
            <b>{{$t('username')}}</b> {{detailModal.content.username}}<br>
            <b>{{$t('name')}}</b> {{detailModal.content.first_name}} {{detailModal.content.last_name}}<br>
            <b>{{$t('email')}}</b> {{detailModal.content.email}}<br>
            <b>{{$t('is_superuser')}}? </b>{{detailModal.content.is_superuser}}<br>
            <b>Suscrito a notificaciones por correo ? </b>{{detailModal.content.user_info ? detailModal.content.user_info.email_subscription : ''}}<br>
            <b>{{$t('is_api_user')}}? </b>{{detailModal.content.user_info ? detailModal.content.user_info.is_api_user : ''}}<br>
            <b>{{$t('is_active')}}?</b> {{detailModal.content.is_active}}<br>
            <h5 v-if="detailModal.content.groups_detail">{{$t('groups')}}</h5>
            <ul>
              <li v-for="(groups, index) in detailModal.content.groups_detail" :key="index">
                {{ _.capitalize(groups.name) }}
              </li>
            </ul>
            <h5 v-if="detailModal.content.app_user_permissions_detail">{{$t('permissions')}}</h5>
            <ul>
              <li v-for="(permission, index) in detailModal.content.app_user_permissions_detail" :key="index">
                {{ _.capitalize(permission.permission.name) }}
              </li>
            </ul>

            <h5 v-if="detailModal.content.app_sections_tree">{{$t('sections')}}</h5>
            <ul>
              <li v-for="(section, index) in detailModal.content.app_sections_tree" :key="index">
                {{ section.name  }}
              </li>
            </ul>
          </td>
        </tr>
      </table>

    </b-modal>

    <!-- Create-Update modal -->
    <b-modal 
      :id="createUpdateModal.id"
      v-model="createUpdateModalShow"
      :title="createUpdateModal.title"
      @ok="onFormSubmit"
      :size="action === 'create' || action === 'password_change' ? 'sm' : 'lg'"
      >
        <UserUpdateForm 
          v-if="action === 'update'" 
          :validator="$v.updateForm"
          :onformsubmit="onFormSubmit"
          :onphotosubmit="onPhotoSubmit"
          :form="updateForm">
        </UserUpdateForm>
        <UserCreationForm 
          v-if="action === 'create'" 
          :validator="$v.createForm"
          :onformsubmit="onFormSubmit"
          :form="createForm"
          :isthirdpartyuser="isthirdpartyuser"
          :thirdparty="thirdparty"
          >
        </UserCreationForm>
        <PasswordUpdateForm 
          v-if="action === 'password_change'" 
          :validator="$v.updatePwForm"
          :onformsubmit="onFormSubmit"
          :form="updatePwForm">
        </PasswordUpdateForm>
      <template v-slot:modal-footer="{ ok }">
          <b-button
            variant="outline-primary rounded-lg shadow"
            class="float-right"
            @click="createUpdateModalShow = !createUpdateModalShow"
          >
            Cancelar
          </b-button>
        <b-button
          type="submit"
          @click="ok"
          variant="primary rounded-lg shadow"
          :disabled="action === 'create' ? $v.createForm.$invalid || isSubmitting : action === 'update' ? $v.updateForm.$invalid || isSubmitting : $v.updatePwForm.$invalid || isSubmitting"
        >
          <span
            v-if="!isSubmitting"
            >
            {{ $t('submit') }}
          </span>
          <b-spinner
            v-if="isSubmitting"
            small
            label="Spinning"
            variant="light"
            >
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
    
    <b-modal
      id="delete-modal"
      v-model="deleteModalShow"
      title="Eliminar usuario"
      ok-title="Delete"
      ok-variant="danger"
      @hidden="resetDeleteModal"
      @ok="deleteUser"
      >
      <p>
        {{ $t('are_sure_delete') }} el {{$t('user')}} {{ toDelete.username }} ?
      </p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="outline-primary shadow rounded" @click="cancel">
          {{ $t('cancel') }}
        </b-button>
        <b-button
          variant="danger shadow rounded"
          :disabled="isSubmitting"
          @click="ok">
          <span
            v-if="!isSubmitting"
            >
            {{ $t('delete') }}
          </span>
          <b-spinner
            v-if="isSubmitting"
            small
            label="Spinning"
            variant="light"
            >
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
    </b-container>

</template>
